

































































































































































import { Component, Vue, Ref, Watch } from "vue-property-decorator";
import { AuthModule, AppModule, SurveyModule } from "@/store";
import { UserProfile, Question, SurveyType, Answer, SurveyStatus, SurveyStatusResult } from "@/interfaces";
import { notifyError, notifySuccess } from "@/common/notify";
import { parseJwt, validateQuestions, validateQuestionsRequired } from "@/common/utils";

import { QForm } from "quasar";
import SurveyCompletedDialog from "@/components/SurveyCompletedDialog.vue";
import SurveyConfirmDialog from "@/components/SurveyConfirmDialog.vue";

@Component({
  components: {
    MenuRight: () => import("@/components/MenuRight.vue"),
    MenuLeft: () => import("@/components/MenuLeft.vue"),
    MenuLeftAdmin: () => import("@/components/MenuLeftAdmin.vue"),
  },
})
export default class Default extends Vue {
  @AuthModule.bindings.Getter
  authenticated!: boolean;

  @AuthModule.bindings.Getter
  authToken!: string | null;

  @AuthModule.bindings.Getter
  statusBySection!: (section: SurveyType) => SurveyStatus;

  @AuthModule.bindings.State
  profile!: UserProfile;

  @AppModule.bindings.State
  previousPath!: string;

  @AuthModule.bindings.Mutation
  logout!: () => void;

  @AuthModule.bindings.State
  status!: SurveyStatusResult;

  @SurveyModule.bindings.State
  allQuestions!: Question[];

  @SurveyModule.bindings.State
  questions!: Question[];

  @SurveyModule.bindings.State
  answers!: Answer[];

  @SurveyModule.bindings.State
  type!: SurveyType;

  @SurveyModule.bindings.Getter
  canGoNext!: boolean;

  @SurveyModule.bindings.Getter
  canGoPrev!: boolean;

  @SurveyModule.bindings.State
  completing!: boolean;

  @SurveyModule.bindings.State
  surveyId!: string;

  @AuthModule.bindings.Getter
  isAdministrator!: boolean;

  @Ref("survey-form")
  surveyForm!: QForm;

  bannerTitle = process.env.VUE_APP_BANNER;

  unquotedRouting = {
    governance: {
      title: "Modifiche salvate.",
      editTitle: null,
      subtitle: "",
      routeButton: "Compila prodotti e mercati",
      to: "/products-markets",
      exitButton: "Torna alla Home",
    },
    macroproduct: {
      title: "Nuovo Prodotto salvato correttamente",
      editTitle: "Prodotto salvato correttamente",
      subtitle: "Desideri procedere con la compilazione del Prodotto turistico?",
      routeButton: "Compila prodotto turistici",
      to: "/product",
      exitButton: "Esci",
    },
    product: {
      title: "Congratulazioni! Nuovo Prodotto salvato correttamente.",
      editTitle: "Congratulazioni! Prodotto salvato correttamente.",
      subtitle:
        "Desideri procedere con la compilazione degli attrattori e i mercati associati a questo prodotto o aggiungere un nuovo prodotto?",
      routeButton: "Aggiungi prodotto",
      to: "/product",
      exitButton: "Esci",
    },
    attraction: {
      title: "Attrattore salvato correttamente",
      editTitle: null,
      subtitle:
        "Desideri procedere con la compilazione degli attrattori e i mercati associati a questo prodotto o aggiungere un nuovo attrattore?",
      routeButton: "Aggiungi attrattore",
      to: "/attractors",
      exitButton: "Esci",
    },
    market: {
      title: "Mercato salvato correttamente",
      editTitle: null,
      subtitle: "Desideri aggiungere un nuovo mercato o uscire?",
      routeButton: "Aggiungi mercato",
      to: "/markets",
      exitButton: "Esci",
    },
    infopoint: {
      title: "Punto informativo salvato correttamente",
      editTitle: null,
      subtitle: "Desideri procedere con un altro Punto informativo? ",
      routeButton: "Aggiungi analisi",
      to: "/hospitality-infopoint",
      exitButton: "Esci",
    },
    brand: {
      title: "Congratulazioni! Brand salvato correttamente",
      editTitle: null,
      subtitle: "Desideri procedere con la compilazione di un altro brand?",
      routeButton: "Nuovo Brand",
      to: "/promotion-brand-equity",
      exitButton: "Esci",
    },
  };

  quotedRouting = {
    "analysis-attraction": {
      title: "Analisi dell'Attrattore salvata correttamente",
      editTitle: null,
      subtitle: "Desideri procedere con l'analisi di un altro Attrattore?",
      routeButton: "Nuova Analisi",
      to: "/analysis-attractiveness",
      exitButton: "Esci",
    },
    "analysis-oldtown": {
      title: "Analisi del Centro Storico salvata correttamente",
      editTitle: null,
      subtitle: "Desideri procedere con l'analisi di un altro Centro Storico?",
      routeButton: "Nuova Analisi",
      to: "/analysis-historical-centres",
      exitButton: "Esci",
    },
    "strategy-attraction": {
      title: "Obiettivo salvato correttamente",
      editTitle: null,
      subtitle: "Desideri procedere con la compilazione di un altro obiettivo?",
      routeButton: "Nuovo Obiettivo",
      to: "/attraction-strategies",
      exitButton: "Esci",
    },
    "initiative-attraction": {
      title: "Iniziativa salvata correttamente",
      editTitle: null,
      subtitle: "Desideri procedere con la compilazione di un'altra iniziativa?",
      routeButton: "Nuova Iniziativa",
      to: "/attraction-initiative",
      exitButton: "Esci",
    },
    "analysis-accessibility": {
      title: "Analisi accessibilità salvata correttamente",
      editTitle: null,
      subtitle: "",
      routeButton: "Continua",
      to: "/management-destination-access",
      exitButton: "Esci",
    },
    "analysis-hospitality": {
      title: "Analisi ospitalità salvata correttamente",
      editTitle: null,
      subtitle: "Desideri procedere con le Strategie per Migliorare l'Accoglienza?",
      routeButton: "Continua",
      to: "/hospitality-strategies",
      exitButton: "Esci",
    },
    "strategy-accessibility": {
      title: "Obiettivo salvato correttamente",
      editTitle: null,
      subtitle: "Desideri procedere con la compilazione di un altro obiettivo?",
      routeButton: "Nuovo Obiettivo",
      to: "/accessibility-strategies",
      exitButton: "Esci",
    },
    "initiative-accessibility": {
      title: "Iniziativa salvata correttamente",
      editTitle: null,
      subtitle: "Desideri procedere con la compilazione di un'altra iniziativa?",
      routeButton: "Nuova Iniziativa",
      to: "/accessibility-initiative",
      exitButton: "Esci",
    },
    "initiative-hospitality": {
      title: "Iniziativa salvata correttamente",
      editTitle: null,
      subtitle: "Desideri procedere con la compilazione di un'altra iniziativa?",
      routeButton: "Nuova Iniziativa",
      to: "/hospitality-initiative",
      exitButton: "Esci",
    },
    "strategy-hospitality": {
      title: "Obiettivo salvato correttamente",
      editTitle: null,
      subtitle: "Desideri procedere con la compilazione di un altro obiettivo?",
      routeButton: "Nuovo Obiettivo",
      to: "/hospitality-strategies",
      exitButton: "Esci",
    },
    "analysis-planning": {
      title: "Congratulazioni! Scelta salvata correttamente",
      editTitle: null,
      subtitle: "Desideri procedere con la scelta dei canali per un altro prodotto/mercato?",
      routeButton: "Nuova Scelta",
      to: "/promotion-trip-planning",
      exitButton: "Esci",
    },
    "analysis-positioning": {
      title: "Congratulazioni! Analisi salvata correttamente",
      editTitle: null,
      subtitle: "Desideri procedere con la compilazione di un'altra analisi canale?",
      routeButton: "Nuova Analisi",
      to: "/promotion-channel-positioning",
      exitButton: "Esci",
    },
    "strategy-awareness": {
      title: "Congratulazioni! Obiettivo salvato correttamente",
      editTitle: null,
      subtitle: "Desideri procedere con la compilazione di un altro obiettivo?",
      routeButton: "Nuovo Obiettivo",
      to: "/promotion-strategy-awareness",
      exitButton: "Esci",
    },
    "initiative-awareness": {
      title: "Congratulazioni! Iniziativa salvata correttamente",
      editTitle: null,
      subtitle: "Desideri procedere con la compilazione di un'altra iniziativa?",
      routeButton: "Nuova Iniziativa",
      to: "/promotion-initiative-awareness",
      exitButton: "Esci",
    },
    "strategy-visibility": {
      title: "Congratulazioni! Obiettivo salvato correttamente",
      editTitle: null,
      subtitle: "Desideri procedere con la compilazione di un altro obiettivo?",
      routeButton: "Nuovo Obiettivo",
      to: "/promotion-strategy-visibility",
      exitButton: "Esci",
    },
    "initiative-visibility": {
      title: "Congratulazioni! Iniziativa salvata correttamente",
      editTitle: null,
      subtitle: "Desideri procedere con la compilazione di un'altra iniziativa?",
      routeButton: "Nuova Iniziativa",
      to: "/promotion-initiative-visibility",
      exitButton: "Esci",
    },
    "initiative-validated": {
      title: "Congratulazioni! Iniziativa salvata correttamente",
      editTitle: "Congratulazioni! Iniziativa modificata correttamente",
      subtitle: "",
      routeButton: "Torna All'Elenco delle iniziative validate",
      to: "/iniziative-validations",
      exitButton: null,
    },
    "user-strategy": {
      title: "Congratulazioni! Strategia salvata correttamente",
      editTitle: "Congratulazioni! Strategia modificata correttamente",
      subtitle: "",
      routeButton: "Torna alla pagina della strategia",
      to: "/strategy-summary",
      exitButton: null,
    },
    "merge-macroproducts": {
      title: "Congratulazioni! Prodotti unificati correttamente",
      editTitle: "Congratulazioni! Prodotti unificati correttamente",
      subtitle: "",
      routeButton: "Torna alla pagina dei Macroprodotti",
      to: "/macro-products-management",
      exitButton: null,
    },
  };

  left = false;
  right = false;
  isSSOAuthenticated = false;

  mounted() {
    if (this.authenticated && !this.isAdministrator) {
      AuthModule.store.getStatus();
    }

    if (this.authenticated) {
      this.left = true;
    }
  }

  @Watch("authToken", { immediate: true })
  onAuthTokenChange(token: string | null) {
    if (token) {
      const parsedToken = parseJwt(token);
      if (parsedToken && parsedToken.authenticated_by) {
        this.isSSOAuthenticated = true;
      } else {
        this.isSSOAuthenticated = false;
      }
    } else {
      this.isSSOAuthenticated = false;
    }
  }

  @Watch("authenticated")
  onAuthenticatedChange(newValue: boolean, oldValue: boolean) {
    if (oldValue !== newValue && oldValue === false) {
      setTimeout(() => {
        this.left = true;
      }, 600);
    }
  }

  onPreSubmit() {
    if (this.type === SurveyType.MERGE_MACROPRODUCTS) {
      this.$q
        .dialog({
          component: SurveyConfirmDialog,
          parent: this,
        })
        .onOk((isOk: boolean) => {
          if (isOk) {
            this.onSubmit();
          }
        });
    } else {
      this.onSubmit();
    }
  }

  async onSubmit() {
    try {
      if (this.surveyId) {
        await SurveyModule.store.updateSurvey(this.surveyId);
      } else {
        await SurveyModule.store.createSurvey();
      }

      if (!this.isAdministrator) {
        await AuthModule.store.getStatus();
      }
      notifySuccess("Sondaggio salvato con successo!");
      SurveyModule.store.setCanExit(true);

      const routeDirection = this.completedRouting[this.type];
      let isSubmitEmitted: boolean;
      this.$q
        .dialog({
          component: SurveyCompletedDialog,
          parent: this,
          title: this.surveyId && routeDirection.editTitle ? routeDirection.editTitle : routeDirection.title,
          subtitle: routeDirection.subtitle,
          exitButton: routeDirection.exitButton,
          routeButton: routeDirection.routeButton,
        })
        .onOk((isOk: boolean) => {
          isSubmitEmitted = isOk;
          if (isOk) {
            this.$router.push(routeDirection.to);
          } else {
            // Esci
            if (this.previousPath != null && !this.previousPath.startsWith("/survey")) {
              this.$router.push(this.previousPath);
            } else {
              this.$router.push("/dashboard");
            }
          }
        })
        .onDismiss(() => {
          if (isSubmitEmitted === undefined) {
            this.$router.push("/dashboard");
          }
        });
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        notifyError(error.response.data.error);
      } else {
        notifyError("Errore imprevisto, non è stato possibile completare il sondaggio. Riprova più tardi!");
      }
      console.log(error);
    }
  }

  doLogout() {
    this.logout();
    this.left = false;
    this.right = false;
  }

  goToHomepage() {
    this.$router.push("/dashboard");
  }

  goToStrategySurvey() {
    if (this.status.has_user_strategy) {
      this.$router.push(`survey/${this.type}/${this.status.has_user_strategy}`).catch(error => console.log(error));
      return;
    }

    this.$router.push(`survey/${this.type}`).catch(error => console.log(error));
  }

  goToSurvey() {
    const find = this.statusBySection(SurveyType.GOVERNANCE);

    if (find) {
      this.$router.push(`survey/${this.type}/${find.id}`).catch(error => console.log(error));
      return;
    }

    this.$router.push(`survey/${this.type}`).catch(error => console.log(error));
  }

  setNextPage() {
    SurveyModule.store.setNextPage();
  }

  setPrevPage() {
    SurveyModule.store.setPrevPage();
  }

  get pageContainerCol() {
    let colSize = 12;

    if (this.authenticated) {
      if (!this.left) {
        colSize -= 1;
      }

      if (!this.right) {
        colSize -= 1;
      }
    }

    return `col-${colSize}`;
  }

  get isFormValid() {
    return validateQuestions(this.questions, this.answers);
  }

  get canSubmitForm() {
    return validateQuestionsRequired(this.allQuestions, this.answers);
  }

  get completedRouting() {
    const unquotedRouting = { ...this.unquotedRouting };
    const macroProductKey = "macroproduct";

    unquotedRouting[macroProductKey] = {
      title: this.isAdministrator ? "Prodotto turistico salvato correttamente" : "Nuovo Prodotto salvato correttamente",
      editTitle: this.isAdministrator ? "Prodotto turistico salvato correttamente" : "Prodotto salvato correttamente",
      subtitle: this.isAdministrator
        ? ""
        : "Il prodotto è in attesa di validazione da parte di Toscana Promozione Turistica, che potrà integrare le informazioni esistenti e contattarti se necessario. Nel frattempo puoi proseguire il lavoro sugli altri prodotti.",
      routeButton: this.isAdministrator ? "Gestione prodotti turistici" : "Lista dei prodotti turistici",
      to: this.isAdministrator ? "/macro-products-management" : "/product",
      exitButton: "Esci",
    };

    return {
      ...unquotedRouting,
      ...this.quotedRouting,
    };
  }

  get isDocumentAreaRoute() {
    return this.$route.name === "documents";
  }
}
